import { render, staticRenderFns } from "./WebSocket.vue?vue&type=template&id=f763d8dc&scoped=true"
import script from "./WebSocket.vue?vue&type=script&lang=js"
export * from "./WebSocket.vue?vue&type=script&lang=js"
import style0 from "./WebSocket.vue?vue&type=style&index=0&id=f763d8dc&prod&lang=css"
import style1 from "./WebSocket.vue?vue&type=style&index=1&id=f763d8dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f763d8dc",
  null
  
)

export default component.exports